import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import { WiMuleSQL } from "../services/WiMuleSQL";

export function useValidateWiMuleToken() {
  const { userDetails } = useContext(UserContext);

  const validateToken = async () => {
    try {
      const response = await fetch(`${WiMuleSQL}/api/Auth/ValidateToken`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userDetails.userWiMuleToken}`,
        },
      });
      if (!response.ok) {
        // Handle token clearing logic here
        throw new Error(`WiMuleToken Validation Failed: ${response.status}`);
      }
      return true;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return validateToken;
}
